export const SECONDARY_WORD = 'secondaryWord';
export const PRIMARY_WORD = 'primaryWord';
